import React from 'react'

import * as Card from '../Card'

export interface IInvitationsProps {
  attendeeList?: boolean
  invitations: any[] | null // Anything typed as 'any' WAS utilizing 'EventInvitation' from the epc schema
  onSelectInvitation?: (invitation: any) => void
  onSelectCurrentUser?: (invitation: any) => void
  currentUserProfileId?: string
  showStatus?: boolean
}

const INVITATION_CARD_STYLE = 'flex-wrap flex-col sm:flex-row px-2 py-2 my-2'
const ATTENDEE_STYLE = 'w-full md:w-1/2 m-0 box-border p-1'

export const Invitations: React.FC<IInvitationsProps> = ({
  attendeeList,
  currentUserProfileId,
  invitations,
  onSelectInvitation: handleSelectInvitation,
  onSelectCurrentUser: handleSelectCurrentUser,
  showStatus,
}) => {
  const handleClick = (invitation: any): React.MouseEventHandler => (e) => {
    e.preventDefault()
    if (
      invitation.profileId === currentUserProfileId &&
      handleSelectCurrentUser
    ) {
      handleSelectCurrentUser(invitation)
    }
    if (
      invitation.profileId !== currentUserProfileId &&
      handleSelectInvitation
    ) {
      handleSelectInvitation(invitation)
    }
  }
  return (
    <div className="mb-4">
      <Card.View internal={true} className={INVITATION_CARD_STYLE}>
        {invitations
          ? invitations.map((i) => (
              <div key={i.id} className={ATTENDEE_STYLE}>
                {attendeeList ? (
                  <Card.InvitationAttendee
                    invite={i}
                    className="px-2 py-3"
                    onClick={handleClick(i) as any}
                    showStatus={showStatus}
                  />
                ) : (
                  <Card.InvitationProfile
                    invite={i}
                    className="px-2 py-3"
                    onClick={handleClick(i) as any}
                    showStatus={showStatus}
                  />
                )}
              </div>
            ))
          : null}
      </Card.View>
    </div>
  )
}
